import gql from 'graphql-tag';

export const SearchDispatchIssue = gql`
  query SearchDispatchIssue($input: DispatchIssueWithCacheConnectionInput) {
    searchDispatchIssue {
      dispatchIssueTableConnection(input: $input) {
        totalCount
        edges {
          node {
            createdAt
            createdBy
            crewMemberGiftCardCount
            crewMemberName
            crewMemberPhone
            datetime
            deletedAt
            deletedBy
            dispatcherEmployeeId
            dispatcherFirstName
            dispatcherId
            dispatcherLastName
            driverEmployeeId
            driverFirstName
            driverId
            driverLastName
            driverPhone
            flightIssueDescription
            flightLate
            flightType
            id
            managerEmployeeId
            managerFirstName
            managerId
            managerLastName
            outboundFlightInfo
            pushTime
            recoveryCompleted
            recoveryFlightDatetime
            recoveryFlightName
            recoveryFlightNumber
            recoveryNeeded
            rootCause
            rootCauseDescription
            scheduledTime
            station
            taxiCost
            taxiDetails
            taxiUsed
            traceId
            tripAirportCode
            tripFlightNumber
            tripId
            tripKind
            tripLoopName
            tripScheduled
            tripServicerIataAirlineCode
            updatedAt
            updatedBy
            vehicleId
            vehicleTrackingId
            causedBy {
              id
              createdAt
              createdBy
              updatedAt
              updatedBy
              causedById
              causedByFirstName
              causedByLastName
              dispatchIssueId
            }
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;
